import { action } from 'satcheljs';

/**
 * Action to load active retention policies.
 */
export const loadActiveRetentionPolicies = action('LOAD_ACTIVE_RETENTION_POLICIES', () => ({}));
